const StockerCapacityCircle = new URL('../../icons/stocker-capacity-circle.png', import.meta.url).href

export default {
  type: 'StockerCapacityCircle',
  description: 'StockerCapacityCircle',
  icon: StockerCapacityCircle,
  group: 'SCS',
  model: {
    type: 'StockerCapacityCircle',
    cx: 100,
    cy: 100,
    rx: 20,
    ry: 20,
    maxCapacity: 100,
    highWatermark: 100,
    currentUsage: 0
  }
}
